import {
  LOAD_FEATURE_FLAGS,
  LOAD_FEATURE_FLAGS_FAIL,
  LOAD_FEATURE_FLAGS_SUCCESS,
  SIGNOUT_USER,
} from "../constants/ActionTypes";

const INIT_STATE = {
  flags: {},
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOAD_FEATURE_FLAGS:
      return { ...state, loading: true };
    case LOAD_FEATURE_FLAGS_SUCCESS: {
      const flags = Object.fromEntries(
        action.payload?.data?.results?.map(
          ({ name, is_active_for_web_manager }) => [
            name,
            is_active_for_web_manager,
          ]
        )
      );
      return { ...state, loading: false, flags };
    }
    case LOAD_FEATURE_FLAGS_FAIL:
      return { ...state, loading: false };
    case SIGNOUT_USER:
      return INIT_STATE;
    default:
      return state;
  }
};
